import React from "react";
import { Card, Row, Col, Button } from "antd";
import { useSelector } from "react-redux";
import { RiArrowGoBackFill } from "react-icons/ri";
import { EmailDomainCreateForm } from "@components";

const EmailDomainCreate = ({ history }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row align="middle">
              <Col>
                <Button
                  type="link"
                  icon={<RiArrowGoBackFill style={{ fontSize: "2em" }} />}
                  onClick={() => history.push("/super-admin/email/users")}
                  style={{
                    marginRight: "16px",
                    padding: 0,
                    height: "auto",
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Col>
              <Col>
                <h3
                  className="hp-mb-16"
                  style={{
                    fontSize: "1.75em",
                    margin: 0,
                  }}
                >
                  Create Domain Name
                </h3>
              </Col>
            </Row>
            {/* Space */}
            <Row style={{ marginTop: "1em" }} />
            {/* User Email Create Form */}
            <EmailDomainCreateForm />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default EmailDomainCreate;
